import React from 'react';

function Blind() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_241_734)">
        <path d="M70.4764 24H9.52441V35.992H70.4764V24Z" fill="white" />
        <path
          d="M70.4764 36.002H9.52441V47.994H70.4764V36.002Z"
          fill="#F7F4F1"
        />
        <path
          d="M70.4764 48.0061H9.52441V59.9981H70.4764V48.0061Z"
          fill="white"
        />
        <path
          d="M70.4764 60.0081H9.52441V72.0001H70.4764V60.0081Z"
          fill="#F7F4F1"
        />
        <path
          d="M70.4764 14.0959H9.52441V23.9919H70.4764V14.0959Z"
          fill="#F7F4F1"
        />
        <path
          d="M71.2756 11.998C71.2756 11.556 70.9176 11.198 70.4756 11.198H9.52363C9.08163 11.198 8.72363 11.556 8.72363 11.998V72C8.72363 72.442 9.08163 72.8 9.52363 72.8H70.4756C70.9176 72.8 71.2756 72.442 71.2756 72V11.998ZM69.6756 35.192H10.3236V24.8H69.6756V35.192ZM69.6756 47.194H10.3236V36.802H69.6756V47.194ZM69.6756 48.804V59.196H10.3236V48.804H69.6756ZM10.3236 12.798H69.6756V23.19H10.3236V12.798ZM69.6756 71.2H10.3236V60.808H69.6756V71.2Z"
          fill="#84827E"
        />
        <path
          d="M9.524 8H70.476C71.318 8 72 8.682 72 9.524V14.096H8V9.524C8 8.682 8.682 8 9.524 8Z"
          fill="url(#paint0_linear_241_734)"
        />
        <path
          d="M72.0002 14.896H8.0002C7.5582 14.896 7.2002 14.538 7.2002 14.096V9.52395C7.2002 8.24195 8.2422 7.19995 9.5242 7.19995H70.4762C71.7582 7.19995 72.8002 8.24195 72.8002 9.52395V14.096C72.8002 14.538 72.4422 14.896 72.0002 14.896ZM8.8002 13.296H71.2002V9.52395C71.2002 9.12395 70.8762 8.79995 70.4762 8.79995H9.5242C9.1242 8.79995 8.8002 9.12395 8.8002 9.52395V13.296Z"
          fill="#84827E"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_241_734"
          x="5.8002"
          y="5.79995"
          width="71.5996"
          height="71.6001"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.6" dy="1.6" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_241_734"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_241_734"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_241_734"
          x1="17.0017"
          y1="8.54524"
          x2="17.6906"
          y2="16.842"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Blind;
